import { computed, ref } from "vue";
import { ACTIVITY_DRAWER_WIDTH_PX } from "../../../Constants/activityPanelPinned";
import { clampActivityDrawerWidthPx } from "../../../Helpers/panelColumnWidths";
import { persistPanelColumnWidths } from "../../../Helpers/persistPanelColumnWidths";
import { useAppState } from "../../../Stores/AppState";

const drawerWidthPx = ref(ACTIVITY_DRAWER_WIDTH_PX);
const isLiveResizing = ref(false);

export function hydrateActivityDrawerWidthFromUserState(widthPx) {
    if (widthPx == null) {
        return;
    }

    drawerWidthPx.value = clampActivityDrawerWidthPx(widthPx);
}

export function useActivityDrawerWidth() {
    const drawerWidthCssValue = computed(() => `${drawerWidthPx.value}px`);

    function setDrawerWidthPx(widthPx) {
        drawerWidthPx.value = clampActivityDrawerWidthPx(widthPx);
    }

    function persistActivityDrawerWidthPx(widthPx) {
        const clamped = clampActivityDrawerWidthPx(widthPx);
        drawerWidthPx.value = clamped;
        const app_state_store = useAppState();

        return persistPanelColumnWidths({
            activity_drawer_width_px: clamped,
        }).then(() => {
            app_state_store.activity_drawer_width_px = clamped;
        });
    }

    function beginActivityDrawerLiveResize() {
        isLiveResizing.value = true;
    }

    function endActivityDrawerLiveResize() {
        isLiveResizing.value = false;
    }

    return {
        drawerWidthPx,
        drawerWidthCssValue,
        isLiveResizing,
        setDrawerWidthPx,
        persistActivityDrawerWidthPx,
        beginActivityDrawerLiveResize,
        endActivityDrawerLiveResize,
    };
}
